import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/chat/single/hemi")({
	component: RouteComponent,
});

function RouteComponent() {
	return <Outlet />;
}
